import React, { useEffect, useState } from "react";
import { TreeNodeComponent } from "./TreeNodeComponent";
import { Cnt } from "../../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK";
import { EMPTY_GUID } from "../../types/Guid";
import { Spinner } from "react-bootstrap";
import { AppSettings } from "../../AppSettings";

interface Props {
  onViewModels: (node: Cnt.ThreeDeeCrate.SDK.ContainerDTO, path: string[]) => void;
  pathToExpand: string[];
  selectedPath: string[];
  styleValue: Cnt.ThreeDeeCrate.SDK.GraphicalStyleType;
  styleName: string; // ✅ add this
}

export const TreeView: React.FC<Props> = ({ onViewModels, pathToExpand, selectedPath, styleValue, styleName }) => {
  const [rootNode, setRootNode] = useState<Cnt.ThreeDeeCrate.SDK.ContainerDTO | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAndBuildRoot = async () => {
      try {
        setLoading(true);
        const api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.APIUrl);
        // ✅ fetch with style filter if API supports it
        const virtualRoot = await api.container.ReadById(EMPTY_GUID);
        setRootNode(virtualRoot);
      } catch (err) {
        console.error("❌ Failed to load containers", err);
        setRootNode(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAndBuildRoot();
  }, [styleValue]); // ✅ re-fetch root when style changes

  if (loading) return <div><Spinner animation="border" size="sm" /></div>;
  if (!rootNode) return <div>No containers found</div>;

  return (
    <div>
      <TreeNodeComponent
        key={rootNode.Id}
        node={rootNode}
        onViewModels={onViewModels}
        pathToExpand={pathToExpand}
        currentPath={[]}
        selectedPath={selectedPath}
        styleFilter={styleValue} // ✅ pass style down
      styleName={styleName} // ✅ pass it down
      />
    </div>
  );
};
